import { render } from "./FolderContainerList.vue?vue&type=template&id=b89074c2&scoped=true"
import script from "./FolderContainerList.vue?vue&type=script&lang=js"
export * from "./FolderContainerList.vue?vue&type=script&lang=js"

import "./FolderContainerList.vue?vue&type=style&index=0&id=b89074c2&lang=scss&scoped=true"

import exportComponent from "/home/controlcenter/sourcecode/dubiverse/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b89074c2"]])

export default __exports__